import { friendlyImpactTitle, friendlyValence } from '@upright/common/utils';
import { ModelEntityType } from '../input/types';
import { fromImpactScoreIVKey, impactScoreKeys } from '../output/scores/types';

export enum DistributionClass {
  COMPANIES = 'companies',
  FUNDS = 'funds',
}

export const getDistribtionClass = (entityType: ModelEntityType | undefined) => {
  switch (entityType) {
    case ModelEntityType.COMPANY:
      return DistributionClass.COMPANIES;
    case ModelEntityType.GROUP:
    case ModelEntityType.PORTFOLIO:
      return DistributionClass.FUNDS;
    case undefined:
      return undefined;
    default:
      return undefined;
  }
};

export const distributionFeatures = ['nir', 'nis', ...impactScoreKeys] as const;
export type DistributionFeature = (typeof distributionFeatures)[number];

export function friendlyDistributionFeature(feature: DistributionFeature) {
  switch (feature) {
    case 'nis':
      return 'Net impact sum';
    case 'nir':
      return 'Net impact ratio';
    default: {
      const { impactCode, valence } = fromImpactScoreIVKey(feature);
      return `${friendlyImpactTitle(impactCode)} - ${friendlyValence(valence)}`;
    }
  }
}
